import { Auth } from 'aws-amplify';

async function getSkus() {
  const currentSession = await Auth.currentSession();
  const idToken = currentSession.getIdToken().decodePayload();
  return idToken.sku.split(',').map(sku => sku.trim());
}

export default {
  async canCustomizeContent() {
    const skus = await getSkus();
    return (
      skus.includes('SKU-00000296') ||
      skus.includes('SKU-00000326')
    );
  },
  async isTrialUser() {
    const skus = await getSkus();
    return skus.includes('SKU-00000326');
  },
  async hasBoosters() {
    const skus = await getSkus();
    return (
      skus.includes('SKU-00000006') ||
      skus.includes('SKU-00000329')
    );
  },
  async integrationName() {
    const skus = await getSkus();
    const mapping = {
      'SKU-00000379': 'OCN',
      'SKU-00000437': 'Workday',
      'SKU-00000405': 'Oracle',
    };
    const skuSet = new Set(skus);
    for (const [sku, name] of Object.entries(mapping)) {
      if (skuSet.has(sku)) return name;
    }
    return '';
  },
};
